'use client';
import styles from './index.module.scss';

export default function EditorIcon({ className = '', alt = '', pc }: any) {
    return <img className={`${styles.icon} ${className ? className : ''}`} src={pc} />;
}
